<template>
    <div
        v-gtm:type="'Entrance'"
        v-gtm:page="gtmPage"
        v-gtm:@click
        v-gtm:@view
        class="jackpot-wrapper"
        v-on:click="goToEFootballZone()"
    >
        <div
            v-if="isLoaded"
            class="jackpot"
        >
            <div class="jackpot_title">
                {{ jackpotTitle }}
            </div>
            <div class="jackpot_content">
                <div class="content-text">
                    {{ i18n.t('jackpot_up_to') }}
                </div>
                <div class="content-amount">
                    <Odometer
                        v-bind:value="jackpotPoolTotalAmount"
                    />
                </div>
            </div>
        </div>

        <div v-else class="loadingOverlay">
            <StaticSpinner color="var(--jackpotLoadingColor)" />
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { storeToRefs } from 'pinia';
    import { computed, nextTick } from 'vue';
    import { useRouter } from 'vue-router';
    import StaticSpinner from '@/components/common/StaticSpinner.vue';
    import Odometer from '@/components/jackpot/Odometer.vue';
    import { useTotalPoolAmount } from '@/composable/useJackpotData';
    import { scrollToTopImmediate } from '@/core/lib/dom';
    import { i18n } from '@/core/lib/i18n';
    import { SiteStyle } from '@/interface/enum';
    import { useToggleStore } from '@/store/toggleStore';

    const { isJackpotEFootballInBigEventTheme, isSwitchEFootballToSimulationSportsZoneEnabled } = storeToRefs(useToggleStore(SiteStyle.Asia));

    if (isJackpotEFootballInBigEventTheme.value) {
        import('@/components/jackpot/JackpotSideBannerBigEvent.scss');
    } else {
        import('@/components/jackpot/JackpotSideBanner.scss');
    }

    const router = useRouter();

    async function goToEFootballZone() {
        if (isSwitchEFootballToSimulationSportsZoneEnabled.value) {
            await router.push('/cyber-sports');
        } else {
            await router.push('/e-football');
        }
        await nextTick();
        scrollToTopImmediate();
    }

    const { totalPoolAmount } = useTotalPoolAmount();

    const isLoaded = computed(() => totalPoolAmount.value !== null);
    const jackpotPoolTotalAmount = computed(() => totalPoolAmount.value ?? 0);
    const jackpotTitle = computed(() => (isSwitchEFootballToSimulationSportsZoneEnabled.value ? i18n.t('jackpot_cyber_sports') : i18n.t('jackpot_title')));
    const gtmPage = computed(() => (isSwitchEFootballToSimulationSportsZoneEnabled.value ? 'K_JackPot' : 'K_Efootball_JP'));
</script>
